
import React from "react";
import { Investor } from "@/types/investor";
import { Dialog, DialogContent, DialogTitle } from "@/components/ui/dialog";
import { ScrollArea } from "@/components/ui/scroll-area";
import InvestorInfo from "@/components/emails/InvestorInfo";
import { hookDebugUtils } from "@/utils/ai/debugUtils";

interface InvestorDetailsDialogProps {
  investor: Investor | null;
  onClose: () => void;
}

const InvestorDetailsDialog = ({ investor, onClose }: InvestorDetailsDialogProps) => {
  // Safe render helper to prevent rendering objects directly
  const safeRender = (value: any): string => {
    if (value === null || value === undefined) return "";
    if (typeof value === 'string') return value;
    if (typeof value === 'number') return value.toString();
    if (typeof value === 'boolean') return value.toString();
    return hookDebugUtils.safeObjectDisplay(value) || "";
  };
  
  return (
    <Dialog open={!!investor} onOpenChange={(open) => !open && onClose()}>
      <DialogContent className="max-w-2xl">
        <DialogTitle>Investor Details: {safeRender(investor?.firm)}</DialogTitle>
        <ScrollArea className="max-h-[80vh] pr-4">
          {investor && (
            <InvestorInfo 
              investor={investor}
              selectedContactData={null}
              isCustomContact={false}
            />
          )}
        </ScrollArea>
      </DialogContent>
    </Dialog>
  );
};

export default InvestorDetailsDialog;
